import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { abbrNumberFilter } from "app/filters/ngFilters";

const formatAbbr = abbrNumberFilter();

interface IVerificationFooterProps {
    isFetching: boolean;
    totalCount: number;
    publishersCount: number;
}

export const VerificationFooter = ({ isFetching, totalCount, publishersCount }: IVerificationFooterProps) => {
    const { translate } = useTranslate();

    return (
        <Flex
            alignItems="center"
            gap="48px"
            margin="8px 0 0 0"
        >
            {isFetching ? (
                <PixelPlaceholderLoader
                    width={240}
                    height={16}
                />
            ) : (
                <Flex
                    alignItems="center"
                    gap="4px"
                >
                    <Text
                        fontVariant="body2"
                        color={colorsPalettes.carbon[500]}
                    >
                        {translate("ad.intelligence.verification.footer.total_summary", {
                            captures: formatAbbr(totalCount),
                            publishers: formatAbbr(publishersCount),
                        })}
                    </Text>
                </Flex>
            )}
        </Flex>
    );
};
